import {groupBy, isEmpty, isNil} from 'ramda';

import {useGetEmployeeAuthorizationIntegrationQuery} from '@dms/api/customer';

import {isNotNilOrEmpty} from 'shared/web';

import {INTEGRATION_CODES} from '../constants/IntegrationCodes';

export function useUserExternalSystems(userId: string | undefined) {
  const {data: integrationData, isLoading} = useGetEmployeeAuthorizationIntegrationQuery(
    {
      userId: userId ?? '',
    },
    {skip: isNil(userId)}
  );

  const integrationsByCode = groupBy(
    (integration) => integration.integrationCode,
    integrationData ?? []
  );

  const mercedesProfiles = [
    {
      integrationCode: INTEGRATION_CODES.MERCEDES_XENTRY,
      integrations: integrationsByCode[INTEGRATION_CODES.MERCEDES_XENTRY],
    },
    {
      integrationCode: INTEGRATION_CODES.MERCEDES_CLARA,
      integrations: integrationsByCode[INTEGRATION_CODES.MERCEDES_CLARA],
    },
    {
      integrationCode: INTEGRATION_CODES.MERCEDES_DAIMLER_XENTRY,
      integrations: integrationsByCode[INTEGRATION_CODES.MERCEDES_DAIMLER_XENTRY],
    },
  ].filter((item) => isNotNilOrEmpty(item.integrations));

  const otherProfiles = [
    {
      integrationCode: INTEGRATION_CODES.OTHER_SAG,
      integrations: integrationsByCode[INTEGRATION_CODES.OTHER_SAG],
    },
    {
      integrationCode: INTEGRATION_CODES.OTHER_TECRMI,
      integrations: integrationsByCode[INTEGRATION_CODES.OTHER_TECRMI],
    },
    {
      integrationCode: INTEGRATION_CODES.OTHER_INTERCARS,
      integrations: integrationsByCode[INTEGRATION_CODES.OTHER_INTERCARS],
    },
  ].filter((item) => isNotNilOrEmpty(item.integrations));

  const mazdaProfiles = [
    {
      integrationCode: INTEGRATION_CODES.MAZDA_PORTAL,
      integrations: integrationsByCode[INTEGRATION_CODES.MAZDA_PORTAL],
    },
  ].filter((item) => isNotNilOrEmpty(item.integrations));

  const isWithoutExternalSystems = [mazdaProfiles, mercedesProfiles, otherProfiles].every(isEmpty);

  return {
    mercedesProfiles,
    otherProfiles,
    mazdaProfiles,
    isWithoutExternalSystems,
    hasExternalSystems: !isWithoutExternalSystems,
    isLoading,
  };
}
